import React, { memo, useCallback, useEffect, useState } from 'react';
import uniqueId from 'lodash/uniqueId';
import { colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CONFIG } from './constants';
import { SvgStyled } from './styled';
function ToggleComponent(props) {
    const { isRightToLeft, size = CONFIG.small, onClickHandler, isActiveElement = false } = props;
    const [isActive, setIsActive] = useState(false);
    const id = uniqueId('toggle-id');
    const handleToggle = useCallback(() => {
        setIsActive(!isActive);
        onClickHandler(!isActive);
    }, [isActive, onClickHandler]);
    const circlePosition = isActive && !isRightToLeft ? 16 : 8;
    const svgPropsCommon = {
        width: size,
        height: size,
        viewBox: `0 0 ${size} ${size}`,
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    };
    const svgRectProps = {
        y: 4,
        width: size,
        height: 16,
        rx: 8,
        fill: isActive ? colorCoreBlack900Base : colorCoreGray500,
    };
    const svgCircleProps = {
        cx: circlePosition,
        cy: 12,
        r: 4,
        fill: colorCoreWhite1000,
    };
    useEffect(() => {
        setIsActive(isActiveElement);
    }, [isActiveElement]);
    return (React.createElement(SvgStyled, { ...svgPropsCommon, onClick: handleToggle, isActive: isActive },
        React.createElement("g", { clipPath: `url(#${id})"` },
            React.createElement("rect", { ...svgRectProps }),
            React.createElement("circle", { ...svgCircleProps })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: id },
                React.createElement("rect", { width: "24", height: "24", fill: colorCoreWhite1000 })))));
}
export const Toggle = memo(ToggleComponent);
